// extracted by mini-css-extract-plugin
export default {"content":"GlobalSearch_content__idq+D","logoImg":"GlobalSearch_logoImg__ZVrv-"};